import Instance from "../../../../Axios";

// New Actions for the app

const GetCredFuncoes = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/funcoes`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_FUNCOES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredFuncoes;